import { GridColDef, GridRowsProp } from '@mui/x-data-grid';
import { useContext, useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { AppContext } from '../../app-context';
import IGridComponent from '../../components/grid/i-grid.component';
import TitlePanel from '../../components/title-panel/title-panel.component';
import { ALL, DAYS_YEAR, EMPTY_STRING, ENQ_CONV_STATUS_ITEMS, ENQ_STATUS_ITEMS, 
         GET_ALL_CUSTOMER_URL, GET_ALL_PRODUCT_URL, PAGE_SIZE } from '../common/constants';
import { formatDate, isEmptyArray } from '../common/util.services';
import './enquiry-list.component.scss';
import { searchEnquiry } from './enquiry.services';
import SearchPanel from '../../components/search-panel/search-panel.component';
import { Grid } from '@mui/material';
import ITextField from '../../components/text-component/textfield/i-textfield.component';
import IDropdown from '../../components/text-component/dropdown/i-dropdown.component';
import dayjs from 'dayjs';
import IDateField from '../../components/text-component/i-datefield/i-datefield.component';
import ICheckbox from '../../components/checkbox/i-checkbox.component';

const EnquiryList = () => {
  const appContext = useContext(AppContext);
  const navigate = useNavigate();
  const rows: GridRowsProp = [];
  const [enquiryData, setEnquiryData] = useState(rows);
  const [amazon, setAmazon] = useState(true);
  const [searchData, setSearchData] = useState<any>({customer: ALL, 
                                                     product: ALL, 
                                                     status: ALL,
                                                     conversionStatus: ALL,
                                                     startDate: dayjs().subtract(DAYS_YEAR, 'day'), 
                                                     endDate: dayjs()});
  const columns: GridColDef[] = [
    { field: 'code', headerName: 'Code', filterable: false, sortable: false, editable: false, width: 120,
      renderCell: (params) => { return <div className="cell-link" onClick={() => { handleEditAction(params.row) }}>{params.row.code}</div> }
    },
    { field: 'customer', headerName: 'Customer', filterable: false, sortable: false, editable: false, width: 150 },
    { field: 'detailsLink', headerName: 'Details', filterable: false, sortable: false, editable: false, width: 80,
      renderCell: (params) => { return params.row.detailsLink.includes('drive.google.com') ?
                                (<Link to={params.row.detailsLink} target="_blank">Details</Link>) : 'NA' }
    },
    { field: 'productCount', headerName: 'Product', filterable: false, sortable: false, editable: false, width: 70,
      renderCell: (params) => { return <div className="cell-link" onClick={() => { openProductPage(params.row) }}>{params.row.productCount}</div> }
    },
    { field: 'costing', headerName: 'Costing', filterable: false, sortable: false, editable: false, width: 70,
      renderCell: (params) => { return <div className="cell-link" onClick={() => { openCostingPage(params.row) }}>{params.row.costing}</div> }
    },
    { field: 'order', headerName: 'Order', filterable: false, sortable: false, editable: false, width: 70,
      renderCell: (params) => { return <div className="cell-link" onClick={() => { openOrderPage(params.row) }}>{params.row.order}</div> }
    },
    { field: 'schedule', headerName: 'Schedule', filterable: false, sortable: false, editable: false, width: 85 },
    { field: 'status', headerName: 'Status', filterable: false, sortable: false, editable: false, width: 120 },
    { field: 'conversionStatus', headerName: 'Conversion Status', filterable: false, sortable: false, editable: false, width: 150 },
    { field: 'enquiryDate', headerName: 'Enq Date', filterable: false, sortable: false, editable: false, width: 100,
      valueFormatter: (value: any) => formatDate(value)
    },
    { field: 'remarks', headerName: 'Remarks', filterable: false, sortable: false, editable: false, width: 200 },
    { field: 'referrer', headerName: 'Referrer', filterable: false, sortable: false, editable: false, width: 100 },
  ];
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(PAGE_SIZE);
  const [totalRows, setTotalRows] = useState(0);

  useEffect(() => {
    if (isEmptyArray(rows)) {
      searchData.amazon = amazon;
      searchEnquiry(searchData, page, pageSize, appContext,
        (response: any) => {
          setEnquiryData(response.data.data);
          setTotalRows(response.data.totalElements);
          appContext.setShowLoader(false);
          setLoading(false);
        }, (error: any) => {
          console.log(error);
          appContext.setShowLoader(false);
          appContext.setErrorMessage(error.message);
          setLoading(false);
        });
    }
  }, [searchData, page, pageSize]);

  const openCostingPage = (row: any) => {
    if(row.costing > 0) {
      navigate('../costing-list/enq/' + row.code)
    }
  }

  const openOrderPage = (row: any) => {
    if(row.order > 0) {
      navigate('../enquiry/order/enq/' + row.code)
    }
  }

  const openProductPage = (row: any) => {
    if(row.productCount > 0) {
      navigate('../enquiry/product/list/' + row.rowId)
    }
  }

  const handleEditAction = (row: any) => {
    navigate(EMPTY_STRING + row.rowId);
  };

  const addEnquiry = () => {
    navigate('new');
  }

  const search = (data: any) => {
    setSearchData(data);
  }

  const onPaginationModelChange = (evt: any) => {
    setPage(evt.page);
    setPageSize(evt.pageSize);
  }

  const getSearchComponent = () => {
    return <SearchPanel search={search} formData={searchData}>
      <Grid container spacing={1} alignItems="center">
        <Grid xs={1.5}>
          <ITextField name='searchText' label='Search Text' />
        </Grid>
        <Grid xs={1.5}>
          <IDropdown name='customer' label='Customer' url={GET_ALL_CUSTOMER_URL} allItemRequired={true}/>
        </Grid>
        <Grid xs={1}>
          <ICheckbox name='amazon' label='Amazon' defaultChecked={true}
            onChangeEvent={(e: any) => {setAmazon(e.target.checked)}}/>
        </Grid>
        <Grid xs={2}>
          <IDropdown name='product' label='Product' url={GET_ALL_PRODUCT_URL} allItemRequired={true} />
        </Grid>
        <Grid xs={1.5}>
          <IDropdown name='status' label='Enq Status' itemList={ENQ_STATUS_ITEMS} allItemRequired={true} />
        </Grid>
        <Grid xs={1.5}>
          <IDropdown name='conversionStatus' label='Conv Status' itemList={ENQ_CONV_STATUS_ITEMS} allItemRequired={true} />
        </Grid>
        <Grid xs={1.5}>
          <IDateField name='startDate' label='Start Date' />
        </Grid>
        <Grid xs={1.5}>
          <IDateField name='endDate' label='End Date' />
        </Grid>
      </Grid></SearchPanel>
  }

  const getMainPanel = () => {
    return <>
      {getSearchComponent()}
      <IGridComponent title={''} rows={enquiryData} columns={columns} loading={loading}
        paginationType="server" paginationModelChange={onPaginationModelChange} totalRows={totalRows}
        showAction={false} handleEditAction={handleEditAction} showAddBtn={true}
        showApproveAction={false} showDeleteAction={false} showUpAction={false} showDownAction={false}
        getRowId={(row: any) => row.rowId} addRow={addEnquiry} maxHeight={450}/>
    </>
  }

  return <TitlePanel title='Enquiries' panelBody={getMainPanel()} />
}

export default EnquiryList;